import { GetTeamSubscriptionMetricsAppsSummaryTotalIndividualQuery } from '../../../../../src/interface/queries/team-metrics/subscription/get-team-subscription-metrics-apps-summary-total-individual.query';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { TeamSubscriptionMetricsAppsSummaryTotalIndividualAggregateRootMapper } from '../../../../infrastructure/mappers/team-metrics/subscription/team-subscription-metrics-app-summary-total-individual.aggregate-root.mapper';
import { GetTeamSubscriptionMetricsAppsSummaryTotalIndividualRequestDto } from '../../../../../src/interface/dtos/team-metrics/subscription/get-team-subscription-metrics-apps-summary-total-individual.request.dto';
import { GetTeamSubscriptionMetricsAppsSummaryResponseDto } from '../../../../../src/interface/dtos/team-metrics/subscription/get-team-subscription-metrics-apps-summary.response.dto';

export class GetTeamSubscriptionMetricsAppsSummaryTotalIndividualController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetTeamSubscriptionMetricsAppsSummaryTotalIndividualQuery,
    protected readonly mapper: TeamSubscriptionMetricsAppsSummaryTotalIndividualAggregateRootMapper
  ) {}

  async get(
    props: GetTeamSubscriptionMetricsAppsSummaryTotalIndividualRequestDto
  ): Promise<GetTeamSubscriptionMetricsAppsSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `TeamSubscriptionMetricsAppsSummaryTotalIndividualComponentController.get encountered an error ${error}`
      );
    }
  }
}
